// extracted by mini-css-extract-plugin
export var lg = "_fg-4";
export var md = "_fg-3";
export var reactTimePickerInputGroupAmPm = "_fg-6";
export var redoTimePicker = "_fg-0";
export var sm = "_fg-2";
export var xl = "_fg-5";
export var xs = "_fg-1";